import React from 'react';
import { useSelector} from 'react-redux';
import { Divider } from 'rsuite';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {generateAddressString}  from '../../../../app/common/services/vehicle.service';
import {BackIcon} from '../svg/iconsSvg';


export const ProfileMyData = ({onBack, onForward, style}) => {

    const userDetails = useSelector(state => state.userDetails);

    const goBack = () => onBack(3);

    const editUserData = () => {
        onForward(5);
    }

    const editEmail = () => {
        onForward(6);
    }

    const renderAddress = () => {
        if(!userDetails?.userAddresses || !userDetails?.userAddresses?.length) return;

        let address = userDetails?.userAddresses.find(obj => obj.isUserAddress);

        address = address ? generateAddressString(address, true) : null

        return <p style={{width: '70%'}}>{address}</p>
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Моите данни</h6>
            </div>
            <Divider />
     
            <div className="profile-data" style={{marginTop: '20px'}}>
                <div>
                    <h6>Име</h6>
                    <p>{userDetails?.fullName}</p>
                    <h6>ЕГН</h6>
                    <p>{userDetails?.userPubId}</p>
                    <h6>Телефон</h6>
                    <p>{userDetails?.mobTelephone}</p>
                </div>
                <EditOutlinedIcon className='icon' onClick={editUserData}/>
            </div>
            <div className="profile-data" style={{marginBottom: '20px'}}>
                <div>
                    <h6>Email</h6>
                    <p>{userDetails?.email}</p>
                    <h6>Адрес</h6>
                    {renderAddress()}
                </div>
                <EditOutlinedIcon className='icon' onClick={editEmail} />
            </div>
        </div>
    )
}

export default ProfileMyData;